/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC } from "react";
import { Avatar, Box, Button, InputAdornment, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import classes from "./style";

export interface MessageAreaProps {
  withSubmitButton: boolean;
  clearOnSubmit?: boolean;
  handleSubmit: (e: any) => void;
}

const MessageArea: FC<MessageAreaProps> = ({
  withSubmitButton,
  clearOnSubmit,
  handleSubmit,
}: MessageAreaProps) => {
  const [message, setMessage] = React.useState<string | null>(null);
  return (
    <Box sx={classes.msgZone}>
      <TextField
        placeholder="Rédiger le message"
        color="secondary"
        onChange={(e: any) => setMessage(e.target.value)}
        value={message}
        fullWidth
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(message);
            if (clearOnSubmit) {
              setMessage('');
            }
          }
        }}
        InputProps={{
          inputProps: { maxlength: 300 },
          endAdornment: (
            <InputAdornment position="start" style={{ cursor: "pointer" }}>
              <SendIcon
                onClick={() => {
                  handleSubmit(message);
                  if (clearOnSubmit) {
                    setMessage('');
                  }
                }}
                color={message ? "primary" : "secondary"}
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default MessageArea;
